import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_2 = { class: "secondary--font mt-1 text-center steps-count" }
const _hoisted_3 = { class: "text-caption secondary--font" }

import { computed } from 'vue';
  import { navigateToUrl } from 'single-spa';
  import { useUserStore } from '@/lib/stores';
  import { onBoardingService } from '@/lib/services/onBoardingService';

  
export default /*@__PURE__*/_defineComponent({
  __name: 'NavigationMenu',
  setup(__props) {

  const ONBOARDING_PRODUCTS = ['marketing', 'service', 'commerce'] as const;

  const userStore = useUserStore();

  const isCollapsed = computed(() => userStore.isNavigationRail);

  const progressCircularBind = computed(() => ({
    modelValue: onBoardingService.getOnboardingCompletedPercentage.value ?? 0,
    size: 22,
    width: 3,
    color: 'mpBlue',
    bgColor: 'grey',
  }));

  const completedStepsDisplay = computed(
    () => onBoardingService.getOnboardingCompletedSteps.value ?? 0,
  );

  const totalStepsDisplay = computed(
    () => onBoardingService.getOnboardingTotalSteps.value ?? 0,
  );

  const isOnboardingAvailable = computed(() => {
    const hasAccess = ONBOARDING_PRODUCTS.some((product) =>
      userStore.getProductAccess(product),
    );
    return hasAccess && !onBoardingService.isOnboardingCompleted.value;
  });

  function openOnboarding() {
    navigateToUrl(`/accounts/${userStore.getAccountId}/onboarding`);
  }

return (_ctx: any,_cache: any) => {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_divider = _resolveComponent("v-divider")!

  return (isOnboardingAvailable.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_v_tooltip, {
          location: "right",
          text: "Continue where you left off"
        }, {
          activator: _withCtx(({ props: tooltipProps }) => [
            _createVNode(_component_v_list_item, _mergeProps(tooltipProps, {
              density: "compact",
              link: "",
              class: "text-white onboarding-menu-item",
              "min-height": "68",
              onClick: openOnboarding
            }), {
              default: _withCtx(() => [
                (isCollapsed.value)
                  ? (_openBlock(), _createBlock(_component_v_list_item_title, {
                      key: 0,
                      class: "text-uppercase onboarding-item-title"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_progress_circular, _mergeProps(progressCircularBind.value, { class: "flex-shrink-0" }), null, 16),
                        _createElementVNode("div", _hoisted_2, _toDisplayString(completedStepsDisplay.value) + "/" + _toDisplayString(totalStepsDisplay.value), 1)
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_component_v_list_item_title, {
                      key: 1,
                      class: "text-uppercase font-weight-bold onboarding-item-title-expanded"
                    }, {
                      default: _withCtx(() => [
                        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "text-body-2 secondary--font mb-1" }, "Get Started", -1)),
                        _createElementVNode("div", _hoisted_3, [
                          _createVNode(_component_v_progress_circular, _mergeProps(progressCircularBind.value, { class: "mr-2 flex-shrink-0" }), null, 16),
                          _createTextVNode(" " + _toDisplayString(completedStepsDisplay.value) + "/" + _toDisplayString(totalStepsDisplay.value) + " Completed ", 1)
                        ])
                      ]),
                      _: 1
                    }))
              ]),
              _: 1
            }, 16)
          ]),
          _: 1
        }),
        _createVNode(_component_v_divider)
      ]))
    : _createCommentVNode("", true)
}
}

})